var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',{staticClass:"box-row"},[_c('h3',[_vm._v(_vm._s(_vm.header))])]),_c('b-row',{staticClass:"box-row"},[_c('div',[_vm._v(_vm._s(_vm.subHeader))])]),_c('b-row',{staticClass:"box-row"},[_c('ModalButton',{attrs:{"label":_vm.submitButtonLabel},on:{"clicked":function($event){return _vm.$emit('clicked')}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }